import React from 'react';

import { BgColor, TextColor, TextGradient } from 'apps/promo/components/types';
import { useMatchMedia } from 'apps/promo/hooks/useMatchMedia';
import promoBreakpoints from 'apps/promo/theme/promoBreakpoints';
import { CarouselProvider, Slide, Slider } from 'pure-react-carousel';

import { WAIT_BEFORE_SLIDES_IS_ACTIVE } from '../Constants';
import styles from './HighlightedTilesSection.module.css';
import { HighlightedTile } from '../../highlighted-tile/HighlightedTile';

interface HighlightedTileColor {
    titleColor?: TextColor;
    titleGradient?: TextGradient;
    bgColor?: BgColor;
}

interface HighlightedTileData {
    id: string | number;
    icon?: string | string[];
    title?: string;
    text?: string;
    color?: HighlightedTileColor;
}

interface HighlightedTilesSectionProps {
    data?: HighlightedTileData[];
    titleH2?: boolean;
    promoDarkPage?: boolean;
    promoDarkPageNew?: boolean;
}

export const HighlightedTilesSection: React.FC<HighlightedTilesSectionProps> = (props) => {
    const isDesktop = useMatchMedia(promoBreakpoints.desktop1440);
    const isTablet = useMatchMedia(promoBreakpoints.tablet744);
    const hasData = props.data && Array.isArray(props.data);
    const isPlaying = isDesktop && hasData ? props.data!.length > 3 : true;
    const totalSlides = hasData ? props.data!.length : 1;

    const getVisibleSlides = () => {
        if (isDesktop) {
            return 3;
        } else {
            return isTablet ? 1.5 : 1.2;
        }
    };

    return (
        <div className={styles.container}>
            <CarouselProvider
                naturalSlideHeight={100}
                naturalSlideWidth={100}
                visibleSlides={getVisibleSlides()}
                totalSlides={totalSlides}
                isPlaying={isPlaying}
                interval={WAIT_BEFORE_SLIDES_IS_ACTIVE}
                isIntrinsicHeight
                infinite
            >
                <Slider>
                    {hasData &&
                        props
                            .data!.filter((item) => item !== null)
                            .map((item, index) => {
                                const slideClass = index === 0 ? `${styles.tileSlide} ${styles.first}` : styles.tileSlide;
                                return (
                                    <Slide index={index} key={item.id}>
                                        <div className={slideClass}>
                                            <HighlightedTile
                                                promoDarkPage={props.promoDarkPage}
                                                promoDarkPageNew={props.promoDarkPageNew}
                                                icon={item.icon}
                                                title={item.title}
                                                titleH2={props.titleH2}
                                                text={item.text}
                                                color={item.color?.titleColor}
                                                titleGradient={item.color?.titleGradient}
                                                bgColor={item.color?.bgColor}
                                                variant="plain"
                                            />
                                        </div>
                                    </Slide>
                                );
                            })}
                </Slider>
            </CarouselProvider>
        </div>
    );
};
